import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=178003de&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=178003de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178003de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178003de')) {
      api.createRecord('178003de', component.options)
    } else {
      api.reload('178003de', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=178003de&scoped=true&", function () {
      api.rerender('178003de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24fXGZ4EUs7Gy/JS/comp/PopupBox.vue"
export default component.exports